module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/AF-cc4cd255f597ec92c71833f59043869c.png";